var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"express-checkout-container"},[_c('div',{attrs:{"id":"express-checkout-element"}}),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"mb-2"},[_c('Spinner',{attrs:{"size":"small","color":"dark"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }